import * as AdminControlPowerBIConstants from "./AdminControlPowerBIConstants";
import {
  STATUS_FAILURE,
  STATUS_SUCCESS,
  STATUS_PENDING,
} from "Common/constants/commonConstants";
// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require("object.assign");

/**
 * initial state which is managed by AdminControlPowerBIReducer
 */
const initialState = {
  addUserStatus:STATUS_SUCCESS,
  deleteUserStatus:STATUS_SUCCESS,
  addResponse:"",
  deleteResponse:""

};

/**'
 * redux reducer method which takes the current state and the action as input parameters and returns with the new state
 */
export default function AdminControlPowerBIReducer(state = initialState, action) {
  switch (action.type) {
    case AdminControlPowerBIConstants.ADD_USER_TO_GROUP_REQUEST:
          return assign({}, state, {
              addUserStatus:STATUS_PENDING,
            });
          break;
    case AdminControlPowerBIConstants.ADD_USER_TO_GROUP_SUCCESS:
          return assign({}, state, {
              addUserStatus:STATUS_SUCCESS,
              addResponse:action.payload
            });
          break;
    case AdminControlPowerBIConstants.ADD_USER_TO_GROUP_ERROR:
          return assign({}, state, {
              addUserStatus:STATUS_FAILURE,
              addResponse:action.payload
            });
          break;
    case AdminControlPowerBIConstants.DELETE_USER_TO_GROUP_REQUEST:
          return assign({}, state, {
              deleteUserStatus:STATUS_PENDING,
            });
          break;
    case AdminControlPowerBIConstants.DELETE_USER_TO_GROUP_SUCCESS:
          return assign({}, state, {
              deleteUserStatus:STATUS_SUCCESS,
              deleteResponse:action.payload
            });
          break;
    case AdminControlPowerBIConstants.DELETE_USER_TO_GROUP_ERROR:
          return assign({}, state, {
              deleteUserStatus:STATUS_FAILURE,
              deleteResponse:action.payload
            });
          break;
    default:
      return state;
  }
}
